import React from "react";

import {Link} from "@pg-design/link-module";
import {Text} from "@pg-design/text";

import {IBreadcrumb} from "./IBreadcrumb";
import {SeparatorIcon} from "./SeparatorIcon";

interface IProps extends IBreadcrumb {
    className?: string;
    separatorIcon?: React.JSX.Element;
    isLinkingToCurrentLocation?: boolean;
}

export const BreadcrumbsItem = (props: IProps) => {
    const {name, position, url, isLinkingToCurrentLocation, className, separatorIcon} = props;

    return (
        <li className={className} itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
            {isLinkingToCurrentLocation ? (
                <Text variant="info_txt_1" as="span">
                    <span itemProp="name">{name}</span>
                    <meta itemProp="position" content={position.toString()} />
                </Text>
            ) : (
                <Link size="small" href={url} target="_self" itemProp="item">
                    <span itemProp="name">{name}</span>
                    <meta itemProp="position" content={position.toString()} />
                </Link>
            )}

            {separatorIcon || <SeparatorIcon />}
        </li>
    );
};
